module.exports = __webpack_public_path__ + "img/logo.a0776b8c.png";